import { StyleSheet, Font } from '@react-pdf/renderer';

// Register fonts
Font.register({
  family: 'Ubuntu',
  fonts: [
    {
      src: '/fonts/Ubuntu-Regular.ttf',
      fontWeight: 'normal',
    },
    {
      src: '/fonts/Ubuntu-Medium.ttf',
      fontWeight: 'medium',
    },
    {
      src: '/fonts/Ubuntu-Bold.ttf',
      fontWeight: 'bold',
    },
  ],
});

Font.registerEmojiSource({
  format: 'png',
  url: 'https://cdnjs.cloudflare.com/ajax/libs/twemoji/14.0.2/72x72/',
});

export const styles = StyleSheet.create({
  page: {
    fontFamily: 'Ubuntu',
    fontSize: 7.5,
    paddingVertical: 16,
    paddingHorizontal: 18,
  },
  section: {
    marginBottom: 8,
  },
  header: {
    fontSize: 12,
    fontWeight: 'bold',
    marginBottom: 8,
    textAlign: 'center',
    color: '#4F46E5', // primary color
  },
  meta: {
    marginBottom: 6,
    borderBottomWidth: 1,
    borderBottomColor: '#E5E7EB', // gray-200
    paddingBottom: 4,
  },
  metaRow: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginBottom: 2,
  },
  sectionTitle: {
    fontSize: 9,
    fontWeight: 'medium',
    marginBottom: 5,
    color: '#111827', // gray-900
  },
  row: {
    flexDirection: 'row',
    marginBottom: 3,
  },
  col: {
    flex: 1,
    paddingRight: 5,
  },
  col2: {
    flex: 2,
    paddingRight: 5,
  },
  label: {
    fontSize: 6.5,
    color: '#6B7280', // gray-500
    marginBottom: 1,
  },
  value: {
    fontSize: 7.5,
    color: '#111827', // gray-900
  },
  expenseItem: {
    backgroundColor: '#F9FAFB', // gray-50
    padding: 6,
    borderRadius: 3,
    marginBottom: 4,
  },
  summary: {
    backgroundColor: '#F9FAFB', // gray-50
    padding: 7,
    borderRadius: 3,
    marginBottom: 7,
  },
  summaryRow: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginBottom: 3,
  },
  signature: {
    marginTop: 20,
    borderTopWidth: 1,
    borderTopColor: '#E5E7EB', // gray-200
    paddingTop: 5,
  },
  // Status badges
  badge: {
    paddingVertical: 1,
    paddingHorizontal: 3,
    borderRadius: 9999,
    fontSize: 6,
    alignSelf: 'flex-start',
  },
  badgeGreen: {
    backgroundColor: '#D1FAE5', // green-100
    color: '#065F46', // green-800
  },
  badgeRed: {
    backgroundColor: '#FEE2E2', // red-100
    color: '#991B1B', // red-800
  },
  badgeYellow: {
    backgroundColor: '#FEF3C7', // yellow-100
    color: '#92400E', // yellow-800
  },
  badgeGray: {
    backgroundColor: '#F3F4F6', // gray-100
    color: '#1F2937', // gray-800
  },
  badgeBlue: {
    backgroundColor: '#DBEAFE', // blue-100
    color: '#1E40AF', // blue-800
  },
});
